import { defineStore } from 'pinia'
import { storage } from '@/utils/storage'
import i18n from '@/locales/index';
import { usePlatform, useCacheData } from "@/hooks";
import MyDialog from '@/plugins/component/MyDialog';
import { queryConfig, queryAppVersion, queryLuckySpinAward, queryDepositProduct } from '@/api';

const { localCache } = useCacheData();

export const useSettingsStore = defineStore('settings', {
  state: () => {
    return {
      isSound: storage.get('isSound', false), // 提示音
      isMusic: storage.get('isMusic', false), // 背景音乐
      csFacebook: '',
      csTelegram: '',
      csOnline: '',
      psFacebook: '',
      psTelegram: '',
      psOnline: '',
      downloadPage: '',
      deviceId: '',
      version: '',
      versionCode: '',
      registerCode: '', // 注册邀请码
      followUs: {},
      depositProduct: null, //充值渠道
      luckySpinRewards: null, // 大转盘 转盘奖励列表
      canPWA: false, // pwa安装是否已准备
      showAndroidWebApp:  false, //是否显示Android Web App下载
      showIOSWebApp: false, //是否显示IOS Web App下载
      showGoToChrome: false, //是否显示打开Chrome
      showAppDownload: !window.$bridge || usePlatform().isAndroid,
    }
  },
  getters: {
    downloadUrl: state => {
      let baseUrl = new URL(state.downloadPage);
      baseUrl.searchParams.append("code", state.registerCode);
      return baseUrl.toString();
    }
  },
  actions: {
    set(key, value = true) {
      this[key] = value;
    },
    initDeviceInfo() {
      if (window.$bridge) {
        window.$bridge.callHandler('getDeviceInfo', '', result => {
          let data = JSON.parse(result);
          this.deviceId = data.deviceId;
          this.version = data.versionName;
          this.versionCode = data.versionCode;
        });
      }
    },
    checkIsChrome() {
      const { isAndroid, isChrome, canCallChrome } = usePlatform()
      if (isAndroid && (!isChrome && canCallChrome)) { // 判断是安卓浏览器且不是chrome
        this.showGoToChrome = true;
      }
    },
    initShowSetting() {
      const { isApp, isIOS, isStandalone, isChrome, isTelegram } = usePlatform()
      if (isApp || isStandalone) {
      } else if (isIOS) {
        if (!isTelegram) {
          this.showIOSWebApp = true;
        }
      } else if (isChrome) {
        this.showAndroidWebApp = true;
      }
    },
    initConfig() {
      return localCache({ 
        cacheKey: 'config', 
        dataApi: queryConfig,
        defaultData: {},
        dataProcessing: config => {
          this.csFacebook = config['cs_facebook'];
          this.csTelegram = config['cs_telegram'];
          this.csOnline = config['cs_online'];
          this.psFacebook = config['ps_facebook'];
          this.psTelegram = config['ps_telegram'];
          this.psOnline = config['ps_online'];
          this.downloadPage = config['download_page'];
          this.followUs = config['follow_us'] || {};
        }
      });
    },
    initLuckySpinAward() {
      return localCache({ 
        cacheKey: 'luckySpinAward',
        defaultData: [],
        dataApi: queryLuckySpinAward,
        dataProcessing: data => {
          this.luckySpinRewards = data
        }
      });
    },
    fetchDepositProduct(callback) {
      // 增加 retrun 为了在main.js中可以使用 Promise.all 等待请求完成
      return queryDepositProduct().then(res => {
        this.depositProduct = res.data || [];
        callback && callback();
      })
    },
    checkAppVersion() {
      if (window.$bridge) {
        queryAppVersion().then(res => {
          let { versionCode, downloadUrl } = res.data || {}
          if (!this.versionCode || this.versionCode < versionCode) {
            MyDialog.confirm({
              message: i18n.global.t('msg.versionUpdate'),
            })
            .then(() => {// on confirm
              window.$bridge.callHandler('openBrowser', downloadUrl)
            })
            .catch(() => {});
          }
        })
      }
    },
    setSound(value) {
      this.isSound = value
      storage.set('isSound', value, null)
    },
    setMusic(value) {
      this.isMusic = value
      storage.set('isMusic', value, null)
    }
  }
})
